import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ellocale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import zhtw from 'element-ui/lib/locale/lang/zh-TW'
import ja from 'element-ui/lib/locale/lang/ja'
import es from 'element-ui/lib/locale/lang/es'
import pt from 'element-ui/lib/locale/lang/pt'
import fr from 'element-ui/lib/locale/lang/fr'
import de from 'element-ui/lib/locale/lang/de'
import id from 'element-ui/lib/locale/lang/id'
import { DEFAULT_LOCALE, ENGLISH_LOCALE, LEGACY_ENGLISH_LOCALE, normalizeLocale, getStoredLocale } from './utils/locale'

Vue.use(VueI18n)

function mergeElementLocale(locale, messages) {
  if (locale === 'zh-Hans-CN') return Object.assign(messages, zhCN)
  if (locale === 'zh-Hant-HK' || locale === 'yue-Hant-HK') return Object.assign(messages, zhtw)
  if (locale === 'en-Latn-US') return Object.assign(messages, en)
  if (locale === 'es-Latn-ES') return Object.assign(messages, es)
  if (locale === 'ja-Jpan-JP') return Object.assign(messages, ja)
  if (locale === 'pt-Latn-PT') return Object.assign(messages, pt)
  if (locale === 'fr-Latn-FR') return Object.assign(messages, fr)
  if (locale === 'de-Latn-DE') return Object.assign(messages, de)
  if (locale === 'id-Latn-ID') return Object.assign(messages, id)
  return messages
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  // 英语以 en-Latn-US 为准；legacy en.json 仅作缺省回填
  if (messages[ENGLISH_LOCALE] && messages[LEGACY_ENGLISH_LOCALE]) {
    messages[ENGLISH_LOCALE] = Object.assign(
      {},
      messages[LEGACY_ENGLISH_LOCALE],
      messages[ENGLISH_LOCALE]
    )
    delete messages[LEGACY_ENGLISH_LOCALE]
  }

  Object.keys(messages).forEach(locale => {
    messages[locale] = mergeElementLocale(locale, messages[locale])
  })

  if (messages[ENGLISH_LOCALE]) {
    messages[LEGACY_ENGLISH_LOCALE] = messages[ENGLISH_LOCALE]
  }

  return messages
}

const initialLocale = typeof localStorage !== 'undefined' && localStorage.getItem('language')
  ? getStoredLocale()
  : normalizeLocale(process.env.VUE_APP_I18N_LOCALE || DEFAULT_LOCALE)

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: normalizeLocale(process.env.VUE_APP_I18N_FALLBACK_LOCALE || DEFAULT_LOCALE),
  messages: loadLocaleMessages(),
  silentTranslationWarn: false
})
ellocale.i18n((key, value) => i18n.t(key, value))

export default i18n
